import React, { useEffect } from "react";
import lions_logo from '../lion_logo.gif';
import lauri_logo from '../lauri_logo.png';
import bg from '../assets/background.jpg';

function Home() {
    // Prevent scrolling on the main page
    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, []);

    return (
        <div
            style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'top',
                minHeight: '100vh',
                width: '100vw',
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 0,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <div
                style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh',
                }}
            >
                <div className="max-w-[700px] w-full text-center flex flex-col bg-black bg-opacity-50 rounded-xl p-2 relative z-10 justify-center">
                    {/*
                    <div>
                            <img src={lauri_logo} alt="lauri-logo" className="block mx-auto h-40"/><br/>                    
                    </div>
                    */}
                    <p className="leading-none text-5xl sm:text-4xl md:text-5xl lg:text-6xl pt-6 mb-2 sm:pt-16 sm:mb-0 font-bold text-white" style={{ WebkitTextStroke: '1px #00529c', textStroke: '1px #00529c', fontFamily: 'Perpetua, Baskerville, Big Caslon, Palatino Linotype, Palatino, serif' }}>MYNÄMÄEN</p>
                    <h3 className="leading-none text-7xl sm:text-6xl md:text-7xl lg:text-8xl mb-2 sm:mb-0 font" style={{ color: '#fece01', WebkitTextStroke: '1px #00529c', textStroke: '1px #00529c', fontFamily: 'Perpetua, Baskerville, Big Caslon, Palatino Linotype, Palatino, serif' }}>Laurin markkinat</h3>
                    <h3 className="leading-none text-4xl sm:text-4xl md:text-5xl lg:text-5xl pt-4 sm:pt-0 lg:font-bold text-white" style={{ fontFamily: 'Perpetua, Baskerville, Big Caslon, Palatino Linotype, Palatino, serif' }}>8.8.2026</h3>
                    <h3 className="leading-none text-4xl sm:text-4xl md:text-4xl lg:text-4xl pt-6 sm:pt-0 text-white" style={{ fontFamily: 'Perpetua, Baskerville, Big Caslon, Palatino Linotype, Palatino, serif' }}>9.00 - 15.00</h3>                    
                    <div>
                            <img src={lions_logo} alt="lions-logo" className="mt-4 block mx-auto h-24 sm:h-26 md:h-16 md:mt-2 lg:h-32"/><br/>                    
                    </div>
                    {/*
                    <Stack direction="row" spacing={2}>
                            <Button className="App-button" variant="outlined" href="/osta-aikaa">Lahjoita</Button>  
                            <Button className="App-button" variant="outlined" href="/varaa-lista">Varaa myyntipaikka</Button>  
                            <Button className="App-button" variant="outlined" href="/admin">Kirjaudu</Button>  
                    </Stack>            
                    */}
                </div>
            </div>
        </div>
    );
}

export default Home;
